/* cramp crew: brand cart drawer (sections=ccr-cart-drawer), menu, qty, gallery, sticky, every /cart/add -> drawer (never /cart) */
(function () {
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var drawer = document.getElementById('ccr-drawer'), inner = document.getElementById('ccr-cart-inner'), menu = document.getElementById('ccr-menu');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function refresh() {
    return fetch(root() + '?sections=ccr-cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j['ccr-cart-drawer'] || ''; var tmp = document.createElement('div'); tmp.innerHTML = html;
      var sec = tmp.firstElementChild; inner.innerHTML = sec ? sec.innerHTML : html;
      var body = inner.querySelector('[data-ccr-n]'); var n = body ? body.getAttribute('data-ccr-n') : '0';
      document.querySelectorAll('[data-ccr-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
    });
  }
  window.CCR = { openCart: function () { return refresh().then(openDrawer); }, refresh: refresh };
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ccr-open],[data-ccr-close],[data-ccr-menu],[data-ccr-qty],[data-ccr-top]');
    if (!t) return;
    if (t.hasAttribute('data-ccr-open')) { e.preventDefault(); refresh().then(openDrawer); }
    else if (t.hasAttribute('data-ccr-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-ccr-menu')) { menu.classList.toggle('is-open'); menu.setAttribute('aria-hidden', menu.classList.contains('is-open') ? 'false' : 'true'); }
    else if (t.hasAttribute('data-ccr-qty')) {
      t.disabled = true;
      fetch(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: t.getAttribute('data-ccr-qty'), quantity: parseInt(t.getAttribute('data-q'), 10) }) }).then(refresh);
    } else if (t.hasAttribute('data-ccr-top')) {
      e.preventDefault(); var x = document.querySelector('.kaching-bundles') || document.getElementById('ccr-buy');
      if (x) window.scrollTo({ top: x.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); }); });
  /* gallery */
  var tr = document.querySelector('[data-ccr-track]'), thumbs = document.querySelector('[data-ccr-thumbs]'), cnt = document.querySelector('[data-ccr-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return; var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) { if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); }); tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true }); upd(); }
  /* sticky buy bar */
  var st = document.querySelector('[data-ccr-sticky]'), form = document.getElementById('ccr-buy');
  if (st && form && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(form);
})();
/* Add to cart NEVER goes to /cart: every /cart/add form opens the cramp crew drawer */
(function () {
  if (window.__ccr_atc) return; window.__ccr_atc = 1;
  function open() { if (window.CCR && window.CCR.openCart) return window.CCR.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 5) return setTimeout(add, 1000 * tries); if (b) b.disabled = false; open(); alert('Something went wrong, please tap the button again.'); });
    })();
  }, false);
})();
